import AVLibraryAdd from 'material-ui/svg-icons/av/library-add';
import ActionAddCircle from 'material-ui/svg-icons/content/add-circle';
import ActionAutorenew from 'material-ui/svg-icons/action/autorenew';
import ActionBackup from 'material-ui/svg-icons/action/backup';
import ActionCheckCircle from 'material-ui/svg-icons/action/check-circle';
import ActionCreditCard from 'material-ui/svg-icons/action/credit-card';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import ActionDone from 'material-ui/svg-icons/action/done';
import ActionDoneAll from 'material-ui/svg-icons/action/done-all';
import ActionDoor from 'material-ui/svg-icons/action/exit-to-app';
import ActionFingerprint from 'material-ui/svg-icons/action/fingerprint';
import ActionHome from 'material-ui/svg-icons/action/home';
import ActionInfoOutline from 'material-ui/svg-icons/action/info-outline';
import ActionInput from 'material-ui/svg-icons/action/input';
import ActionList from 'material-ui/svg-icons/action/list';
import ActionLock from 'material-ui/svg-icons/action/lock';
import ActionPanTool from 'material-ui/svg-icons/action/pan-tool';
import ActionPowerSettingsNew from 'material-ui/svg-icons/action/power-settings-new';
import ActionSchedule from 'material-ui/svg-icons/action/schedule';
import ActionSettings from 'material-ui/svg-icons/action/settings';
import ActionStore from 'material-ui/svg-icons/action/store';
import ActionSupervisorAccount from 'material-ui/svg-icons/action/supervisor-account';
import ActionTimeline from 'material-ui/svg-icons/action/timeline';
import ActionTranslate from 'material-ui/svg-icons/action/translate';
import ActionTrendingDown from 'material-ui/svg-icons/action/trending-down';
import ActionTrendingFlat from 'material-ui/svg-icons/action/trending-flat';
import ActionTrendingUp from 'material-ui/svg-icons/action/trending-up';
import AlertErrorOutline from 'material-ui/svg-icons/alert/error-outline';
import AlertWarning from 'material-ui/svg-icons/alert/warning';
import AttachMoney from 'material-ui/svg-icons/editor/attach-money';
import CommunicationCallSplit from 'material-ui/svg-icons/communication/call-split';
import CommunicationEmail from 'material-ui/svg-icons/communication/email';
import CommunicationVpnKey from 'material-ui/svg-icons/communication/vpn-key';
import ConectRemove from 'material-ui/svg-icons/content/remove';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentAddCircleOutline from 'material-ui/svg-icons/content/add-circle-outline';
import ContentClear from 'material-ui/svg-icons/content/clear';
import ContentContentCopy from 'material-ui/svg-icons/content/content-copy';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentFlag from 'material-ui/svg-icons/content/flag';
import ContentRemoveCircle from 'material-ui/svg-icons/content/remove-circle';
import ContentSort from 'material-ui/svg-icons/content/sort';
import DateRangeIcon from 'material-ui/svg-icons/action/date-range';
import DeviceDvr from 'material-ui/svg-icons/device/dvr';
import EventAvailable from 'material-ui/svg-icons/notification/event-available';
import EventBusy from 'material-ui/svg-icons/notification/event-busy';
import FileCloudDownload from 'material-ui/svg-icons/file/cloud-download';
import FileFileDownload from 'material-ui/svg-icons/file/file-download';
import HardwareSpeaker from 'material-ui/svg-icons/hardware/speaker';
import HardwareSpeakerGroup from 'material-ui/svg-icons/hardware/speaker-group';
import ImageEdit from 'material-ui/svg-icons/image/edit';
import ImageRemoveRedEye from 'material-ui/svg-icons/image/remove-red-eye';
import MapsLayers from 'material-ui/svg-icons/maps/layers';
import MapsLocalAtm from 'material-ui/svg-icons/maps/local-atm';
import MapsParking from 'material-ui/svg-icons/maps/local-parking';
import MapsPlace from 'material-ui/svg-icons/maps/place';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import NavigationArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import NavigationCancel from 'material-ui/svg-icons/navigation/cancel';
import NavigationCheck from 'material-ui/svg-icons/navigation/check';
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import NavigationChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';
import Pause from 'material-ui/svg-icons/av/pause-circle-outline';
import Payment from 'material-ui/svg-icons/action/payment';
import SocialPeople from 'material-ui/svg-icons/social/people';
import ToggleCheckBox from 'material-ui/svg-icons/toggle/check-box';
import ToggleIndeterminateCheckBox from 'material-ui/svg-icons/toggle/indeterminate-check-box';
import ToggleStarBorder from 'material-ui/svg-icons/toggle/star-border';
import Save from 'material-ui/svg-icons/content/save';

export const ActivateIcon = ActionCheckCircle;
export const AddIcon = ContentAdd;
export const AlertIcon = AlertErrorOutline;
export const ApiKeyIcon = CommunicationVpnKey;
export const ArrowRightIcon = NavigationArrowDropRight;
export const BackIcon = NavigationArrowBack;
export const BackupIcon = ActionBackup;
export const BookingsIcon = DateRangeIcon;
export const BookingStatsIcon = ActionTimeline;
export const CampaignIcon = ToggleStarBorder;
export const CanceledIcon = NavigationClose;
export const CheckBoxIcon = ToggleCheckBox;
export const CheckIcon = ActionDone;
export const ChevronLeftIcon = NavigationChevronLeft;
export const ChevronRightIcon = NavigationChevronRight;
export const ClearIcon = ContentClear;
export const CompleteIcon = NavigationCheck;
export const ConfirmIcon = EventAvailable;
export const ContentCopyIcon = ContentContentCopy;
export const ContentIcon = AVLibraryAdd;
export const CreateIcon = ContentCreate;
export const CreateOrderIcon = ContentAddCircleOutline;
export const DashboardIcon = DeviceDvr;
export const DeactivateIcon = ActionAddCircle;
export const DefaultIcon = ConectRemove;
export const DeleteIcon = ActionDelete;
export const DiscountIcon = AttachMoney;
export const DoorIcon = ActionDoor;
export const DownloadIcon = FileCloudDownload;
export const ExitIcon = ActionPowerSettingsNew;
export const FalseIcon = NavigationCancel;
export const FileDownloadIcon = FileFileDownload;
export const FingerPrintIcon = ActionFingerprint;
export const GenerateIcon = ActionAutorenew;
export const HandIcon = ActionPanTool;
export const HomeIcon = ActionHome;
export const ImageEyeIcon = ImageRemoveRedEye;
export const ImageIcon = ImageEdit;
export const IndeterminateCheckBoxIcon = ToggleIndeterminateCheckBox;
export const InfoIcon = ActionInfoOutline;
export const InputIcon = ActionInput;
export const ListIcon = ActionList;
export const LockIcon = ActionLock;
export const MailIcon = CommunicationEmail;
export const MapsPlaceIcon = MapsPlace;
export const MoreVertIcon = NavigationMoreVert;
export const MultiCheckIcon = ActionDoneAll;
export const NullIcon = ContentRemoveCircle;
export const OrderStatsIcon = ActionTimeline;
export const ParkingIcon = MapsParking;
export const PaymentIcon = Payment;
export const PaymentChargedBackIcon = ActionCreditCard;
export const PendingIcon = ActionSchedule;
export const PeopleIcon = SocialPeople;
export const PropertiesIcon = HardwareSpeaker;
export const PropertygroupsIcon = HardwareSpeakerGroup;
export const RefreshIcon = NavigationRefresh;
export const PauseIcon = Pause;
export const SaveIcon = Save;
export const SettingsIcon = ActionSettings;
export const SortIcon = ContentSort;
export const SplitIcon = CommunicationCallSplit;
export const StoreIcon = ActionStore;
export const SubcategoryIcon = MapsLayers;
export const SupervisorAccountIcon = ActionSupervisorAccount;
export const SuspiciousIcon = ContentFlag;
export const TerminateIcon = EventBusy;
export const TranslateIcon = ActionTranslate;
export const TrendingDownIcon = ActionTrendingDown;
export const TrendingFlatIcon = ActionTrendingFlat;
export const TrendingUpIcon = ActionTrendingUp;
export const UserYieldIcon = MapsLocalAtm;
export const WarningIcon = AlertWarning;

export default {
    ActivateIcon,
    AddIcon,
    AlertIcon,
    ApiKeyIcon,
    ArrowRightIcon,
    BackIcon,
    BackupIcon,
    BookingsIcon,
    BookingStatsIcon,
    CampaignIcon,
    CanceledIcon,
    CheckBoxIcon,
    CheckIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ClearIcon,
    ConfirmIcon,
    CompleteIcon,
    ContentCopyIcon,
    ContentIcon,
    CreateIcon,
    CreateOrderIcon,
    DashboardIcon,
    DeactivateIcon,
    DefaultIcon,
    DeleteIcon,
    DiscountIcon,
    DoorIcon,
    DownloadIcon,
    ExitIcon,
    FalseIcon,
    FileDownloadIcon,
    FingerPrintIcon,
    GenerateIcon,
    HandIcon,
    HomeIcon,
    ImageEyeIcon,
    ImageIcon,
    IndeterminateCheckBoxIcon,
    InfoIcon,
    InputIcon,
    ListIcon,
    LockIcon,
    MailIcon,
    MapsPlaceIcon,
    MoreVertIcon,
    MultiCheckIcon,
    NullIcon,
    OrderStatsIcon,
    ParkingIcon,
    PauseIcon,
    PaymentIcon,
    PaymentChargedBackIcon,
    PendingIcon,
    PeopleIcon,
    PropertiesIcon,
    PropertygroupsIcon,
    RefreshIcon,
    SaveIcon,
    SettingsIcon,
    SortIcon,
    SplitIcon,
    StoreIcon,
    SubcategoryIcon,
    SupervisorAccountIcon,
    SuspiciousIcon,
    TerminateIcon,
    TranslateIcon,
    TrendingDownIcon,
    TrendingFlatIcon,
    TrendingUpIcon,
    UserYieldIcon,
    WarningIcon,
};



// WEBPACK FOOTER //
// ./src/assets/materialIcons/materialIcons.js